export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.f476e995.worker.js");
}
